import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="comment-sort"
export default class extends Controller {
  static targets = ["select"]
  static values = {
    commentableId: String,
    commentableType: String,
    loadingId: String,
    frameId: String
  }

  connect() {
    this.onChange = this.onChange.bind(this)
    this.selectTarget.addEventListener('change', this.onChange)
  }

  disconnect() {
    this.selectTarget.removeEventListener('change', this.onChange)
  }

  onChange(event) {
    const sortValue = event.target.value
    const url = this.buildUrl(sortValue)

    if (!url) {
      console.error('Unable to determine comments sort URL for type:', this.commentableTypeValue)
      return
    }

    this.showLoading()

    fetch(url, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then(html => {
        if (Turbo && typeof Turbo.renderStreamMessage === 'function') {
          Turbo.renderStreamMessage(html)
        } else {
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          doc.querySelectorAll('turbo-stream').forEach((stream) => {
            document.body.appendChild(stream)
          })
        }

        // ensure UI reflects current selection when response replaces markup
        this.selectTarget.value = sortValue
      })
      .catch(error => {
        console.error('Error fetching sorted comments:', error)
        const frame = document.getElementById(`comments-frame-${this.commentableIdValue}`)
        if (frame) {
          frame.innerHTML = '<div class="comments-error"><p>Error loading comments. Please try again.</p></div>'
        }
      })
      .finally(() => {
        this.hideLoading()
      })
  }

  buildUrl(sortValue) {
    switch (this.commentableTypeValue) {
      case 'Post':
        return `/posts/${this.commentableIdValue}/comments?sort=${sortValue}`
      case 'AcademyPost':
        return `/academy_posts/${this.commentableIdValue}/comments?sort=${sortValue}`
      default:
        return `/comments?commentable_type=${encodeURIComponent(this.commentableTypeValue)}&commentable_id=${this.commentableIdValue}&sort=${sortValue}`
    }
  }

  showLoading() {
    if (this.loadingIdValue) {
      const loader = document.getElementById(this.loadingIdValue)
      if (loader) loader.classList.add('active')
    }

    const frame = this._frameElement()
    if (frame) {
      this._previousFrameDisplay = frame.style.display
      frame.style.display = 'none'
    }
  }

  hideLoading() {
    if (this.loadingIdValue) {
      const loader = document.getElementById(this.loadingIdValue)
      if (loader) loader.classList.remove('active')
    }

    const frame = this._frameElement()
    if (frame) {
      frame.style.display = this._previousFrameDisplay ?? ''
      this._previousFrameDisplay = undefined
    }
  }

  _frameElement() {
    if (!this.frameIdValue) return null
    return document.getElementById(this.frameIdValue)
  }
}
